<template>
  <section class="login-wrapper">
    <!-- Your existing layout here -->
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>

    <section class="login-content">
      <div class="logo text-center">
        <img src="@/assets/logo-w.png" alt="" width="150" class="mt-2">
        <h2 class="text-dark">{{name_en}}</h2>
        <h4 class="text-dark">{{name}}</h4>
      </div>
      <div class="login-box">
        <!-- Login Form -->
        <form v-if="!isForgotPassword" class="login-form" @submit.prevent="handleLogin">
          <h3 class="login-head">
            <i class="bi bi-person me-2"></i>เข้าสู่ระบบ
          </h3>
          <div class="mb-3">
            <label class="form-label">ชื่อผู้ใช้</label>
            <input v-model="loginForm.username" class="form-control" type="text" placeholder="ชื่อผู้ใช้" autofocus />
          </div>
          <div class="mb-3">
            <label class="form-label">รหัสผ่าน</label>
            <input v-model="loginForm.password" class="form-control" type="password" placeholder="รหัสผ่าน" />
          </div>
          <div class="mb-3">
            <div class="utility">
              <div class="form-check">
                <!-- Uncomment if Stay Signed In is required -->
                <!-- <label class="form-check-label">
                  <input v-model="staySignedIn" class="form-check-input" type="checkbox" />
                  <span class="label-text">Stay Signed in</span>
                </label> -->
              </div>
              <p class="semibold-text mb-2">
                <a href="#" @click.prevent="toggleForgotPassword">ลืมรหัสผ่าน ?</a>
              </p>
            </div>
          </div>
          <div class="mb-3 btn-container d-grid">
            <button class="btn btn-primary btn-block" type="submit" :disabled="loading">
              <i class="bi bi-box-arrow-in-right me-2 fs-5"></i>เข้าสู่ระบบ
            </button>
          </div>
        </form>

        <!-- Forgot Password Form -->
        <form v-else class="login-form" @submit.prevent="handleForgotPassword">
          <h3 class="login-head">
            <i class="bi bi-person-lock me-2"></i>Forgot Password ?
          </h3>
          <div class="mb-3">
            <label class="form-label">EMAIL</label>
            <input v-model="forgotPasswordEmail" class="form-control" type="text" placeholder="Email" />
          </div>
          <div class="mb-3 btn-container d-grid">
            <button class="btn btn-primary btn-block" type="submit">
              <i class="bi bi-unlock me-2 fs-5"></i>RESET
            </button>
          </div>
          <div class="mb-3 mt-3">
            <p class="semibold-text mb-0">
              <a href="#" @click.prevent="toggleForgotPassword">
                <i class="bi bi-chevron-left me-1"></i> Back to Login
              </a>
            </p>
          </div>
        </form>
      </div>
      <div class="text-center">
        <p class="mt-4 mb-2"> © 2025 ระบบบันทึกข้อมูล 5 ส. | โรงพยาบาลวานรนิวาส จังหวัดสกลนคร </p>
        <p class="m-0">พัฒนาโดย นายบัญชาชัย แพงพิมพ์โล้</p>
        <p class="">กลุ่มงานสุขภาพดิจิทัล</p>
      </div>
    </section>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { showErrorAlert } from '../utils/sweetalert2-utils.js';
// import { ref } from 'vue';

export default {
  name: 'Login',
  data() {
    return {
      name: process.env.VUE_APP_NAME,
      name_en: process.env.VUE_APP_NAME_EN,
      isForgotPassword: false,
      loginForm: {
        username: '',
        password: '',
        device_name: 'browser',
      },
      forgotPasswordEmail: '',
      staySignedIn: false,
      loading: false,  // Track loading state
    };
  },
  methods: {
    ...mapActions(['login']),  // Ensure login action is mapped correctly

    async handleLogin() {
      this.loading = true;  // Set loading to true during the request
      try {
        await this.login(this.loginForm);  // Call the login action
        this.$router.push({ name: 'Dashboard' });  // Redirect after successful login
      } catch (error) {
        console.error('Login failed:', error);
        showErrorAlert('Login failed. Please check your credentials.');
      } finally {
        this.loading = false;  // Reset loading state after the request
      }
    },

    handleForgotPassword() {
      console.log('Resetting password for:', this.forgotPasswordEmail);
      // Add logic to reset the password (e.g., call an API)
    },

    toggleForgotPassword() {
      this.isForgotPassword = !this.isForgotPassword;
    },
  },
};
</script>

<style scoped>

</style>
